<script setup>
    // Set up Action filters - currently static lists
    //import multiselect from 'vue-multiselect'
    import { router, useForm } from '@inertiajs/vue3';
    import multiselect from '@vueform/multiselect';
    import { watch } from "vue";
    import { reactive } from "vue";
    import { useI18n } from 'vue-i18n';

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";
    const { locale, fallbackLocale, t} = useI18n({ useScope: 'global' });

    const props = defineProps({
        toolkit: Object,
        actions: Array,
        areas: Array,
        statuses: Array,
        themes: Array,
        sdgs: Array,
        awards: Array,
        filters: Object,
        toolkitFilters: Object,
        currentToolkitTeamUsers: Array,
        team: Object
    });


    // Handle Area drop down translation stuff

    const translated_areas = reactive(props.areas);

    translated_areas.forEach(function (area, key) {
        if (translated_areas.constructor.name != 'Object') {
            translated_areas[key].name = JSON.parse(area.name)
        }
        if (translated_areas[key].name[locale.value] == undefined) {
            translated_areas[key].name = translated_areas[key].name[fallbackLocale.value];
        } else {
            translated_areas[key].name = translated_areas[key].name[locale.value];
        }

    });
    translated_areas.reverse();

    // Handle Award level translation stuff

    const translated_award_levels = reactive(props.awards);

    translated_award_levels.forEach(function (area, key) {
        if (translated_award_levels.constructor.name != 'Object') {
            translated_award_levels[key].name = JSON.parse(area.name)
        }
        if (translated_award_levels[key].name[locale.value] == undefined) {
            translated_award_levels[key].name = translated_award_levels[key].name[fallbackLocale.value];
        } else {
            translated_award_levels[key].name = translated_award_levels[key].name[locale.value];
        }

    });
    translated_award_levels.reverse();

     // Handle Theme translation stuff

     const translated_themes = reactive(props.themes);

     translated_themes.forEach(function (area, key) {
        if (translated_themes.constructor.name != 'Object') {
            translated_themes[key].name = JSON.parse(area.name)
        }
        if (translated_themes[key].name[locale.value] == undefined) {
            translated_themes[key].name = translated_themes[key].name[fallbackLocale.value];
        } else {
            translated_themes[key].name = translated_themes[key].name[locale.value];
        }

    });
    //translated_themes.reverse();

    // handle translating the statuses
    const statuses = props.statuses;
    const translated_statuses = reactive(statuses);

    translated_statuses.forEach(function (status, key) {
        translated_statuses[key].name = t('dashboard.widgets.shared.status.'+translatedActionStatus(translated_statuses[key].id));
    });

    function translatedActionStatus(statusID) {
        let translatedActionStatusButtonLabel = '';
        if ( statusID == 1 ) {
            translatedActionStatusButtonLabel = 'done';
        }
        else if ( statusID == 2 ) {
            translatedActionStatusButtonLabel = 'in_progress';
        }
        else if ( statusID == 3 ) {
            translatedActionStatusButtonLabel = 'not_done';
        }
        else if ( statusID == 4 ) {
            translatedActionStatusButtonLabel = 'not_applicable';
        }
        else {
            translatedActionStatusButtonLabel = 'none';
        }
        return translatedActionStatusButtonLabel;
    }

</script>

<template>

    <div v-if="areas.length > 0" class="action-filter form-control basis-full md:basis-1/3 mb-1">
        <label class="typo__label sr-only">{{ $t('toolkit.filters.area') }}</label>

        <multiselect
            id="filterByArea"
            v-model="toolkitFilters.filterBy.area_ids"
            :options="translated_areas"
            :searchable="true"
            :placeholder="$t('toolkit.filters.area')"
            valueProp="id"
            label="name"
            mode="tags"
            class="md:mr-5 w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md"
            >
        </multiselect>
    </div>

    <div v-if="awards.length > 0" class="action-filter form-control basis-full md:basis-1/3 mb-1">
        <label class="typo__label sr-only">{{ $t('toolkit.filters.award_level') }}</label>

        <multiselect
            id="filterByAward"
            v-model="toolkitFilters.filterBy.award_ids"
            :options="translated_award_levels"
            :searchable="true"
            :placeholder="$t('toolkit.filters.award_level')"
            valueProp="id"
            label="name"
            mode="tags"
            class="md:mr-5 w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md"
            >
        </multiselect>
    </div>

    <div v-if="themes.length > 0" class="action-filter form-control basis-full md:basis-1/3 mb-1">
        <label class="typo__label sr-only">{{ $t('toolkit.filters.theme') }}</label>

        <multiselect
            id="filterByTheme"
            v-model="toolkitFilters.filterBy.theme_ids"
            :options="translated_themes"
            :searchable="true"
            :placeholder="$t('toolkit.filters.theme') "
            valueProp="id"
            label="name"
            mode="tags"
            class="md:mr-5 w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md"
            >
        </multiselect>
    </div>

    <div v-if="statuses.length > 0" class="action-filter form-control basis-full md:basis-1/3 mb-1">
        <label class="typo__label sr-only">{{ $t('toolkit.filters.status') }}</label>

        <multiselect
            id="filterByStatus"
            v-model="toolkitFilters.filterBy.status_ids"
            :options="statuses"
            :searchable="true"
            :placeholder="$t('toolkit.filters.status')"
            valueProp="id"
            label="name"
            mode="tags"
            class="md:mr-5 w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md"
            >
        </multiselect>
    </div>

    <div v-if="currentToolkitTeamUsers.length > 0" class="action-filter form-control basis-full md:basis-1/3 mb-1">
        <label class="typo__label sr-only">{{ $t('toolkit.filters.assigned_to') }}</label>

        <multiselect
            id="filterByAssignedTo"
            v-model="toolkitFilters.filterBy.assigned_to_user_ids"
            :options="currentToolkitTeamUsers"
            :searchable="true"
            :placeholder="$t('toolkit.filters.assigned_to')"
            valueProp="id"
            label="full_name"
            mode="tags"
            class="md:mr-5 w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md"
            >
        </multiselect>
    </div>


    <div v-if="sdgs.length > 0" class="action-filter form-control basis-full md:basis-1/3 mb-1">
        <label class="typo__label sr-only">{{ $t('toolkit.filters.sdg') }}</label>

        <multiselect
            id="filterBySdg"
            v-model="toolkitFilters.filterBy.sdg_ids"
            :options="sdgs"
            :searchable="true"
            :placeholder="$t('toolkit.filters.sdg')"
            valueProp="id"
            label="name"
            mode="tags"
            class="md:mr-5 w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md"
            >
        </multiselect>
    </div>



</template>
